import React from 'react'
import { paths } from '@mc/paths'
import { BaseLink, type BaseLinkProps } from '../BaseLink'

export const SpeechPolicyLink = (props: BaseLinkProps) => (
  <BaseLink {...props} href={paths.privacySpeechPolicy} />
)
